module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpjs_one.0d755a6a.png";